<template>
  <v-container>
    <v-row class="mb-n6">
      <v-col>
        <p>{{ kind.historyTitle }}</p>
      </v-col>
    </v-row>

    <v-card class="mt-6">
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <v-menu
              v-model="fromMenu"
              :close-on-content-click="true"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFrom"
                  label="ເພີ່ມເຂົ້າມາແຕ່ວັນທີ"
                  readonly
                  clearable
                  outlined
                  dense
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker v-model="dateFrom" />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-menu
              v-model="toMenu"
              :close-on-content-click="true"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateTo"
                  label="ຫາວັນທີ"
                  readonly
                  clearable
                  outlined
                  dense
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="dateTo"
                :min="dateFrom || undefined"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="filter"
              append-icon="mdi-magnify"
              label="ຄົ້ນຫາ ຊື່ ຫຼື ເບີໂທ"
              outlined
              dense
              hide-details
              clearable
              @keyup.enter="fetchData(1)"
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <v-btn
              color="primary"
              block
              @click="fetchData(1)"
            >
              ຄົ້ນຫາ
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:[`item.submitter`]="{ item }">
          {{ item.submitter ? item.submitter.name : '' }}
        </template>
        <template v-slot:[`item.reviewer`]="{ item }">
          {{ item.reviewer ? item.reviewer.name : '' }}
        </template>
        <template v-slot:[`item.home_customer`]="{ item }">
          {{ homeLabel(item.home_customer) }}
        </template>
        <template v-slot:[`item.customer_id`]="{ item }">
          <a
            v-if="item.customer_id"
            @click="$openRoute({ name: 'ViewCompanyDetail', params: { id: item.customer_id } })"
          >COM_{{ item.customer_id }}</a>
        </template>
      </v-data-table>
      <Pagination
        v-if="pagination.total_pages > 1"
        :pagination="pagination"
        :offset="offset"
        @paginate="fetchData()"
      />
    </v-card>
  </v-container>
</template>

<script>
import { today } from '@/Helpers/localDate';
import { submissionKind, homeLabel } from './submissionKinds';

export default {
  title() {
    return 'Vientiane Waste Co-Dev|Company Approval History';
  },
  data() {
    return {
      items: [],
      filter: '',
      // Opens on today's records; clear the dates to see every day.
      dateFrom: today(),
      dateTo: today(),
      fromMenu: false,
      toMenu: false,
      offset: 12,
      pagination: {},
      requestSeq: 0,
    };
  },
  computed: {
    kind() {
      return submissionKind(this.$route);
    },
    headers() {
      return [
        ...(this.kind.isConversion ? [{ text: 'ສາຍບ້ານທີ່ປິດ', value: 'home_customer', sortable: false }] : []),
        { text: 'ລະຫັດລູກຄ້າ', value: 'customer_id', sortable: false },
        { text: 'ຊື່ບໍລິສັດ', value: 'company_name' },
        { text: 'ເບີໂທ', value: 'phone' },
        { text: 'ຜູ້ເພີ່ມ', value: 'submitter', sortable: false },
        { text: 'ວັນເວລາເພີ່ມ', value: 'created_at' },
        { text: 'ຜູ້ອະນຸມັດ', value: 'reviewer', sortable: false },
        { text: 'ວັນເວລາອະນຸມັດ', value: 'reviewed_at' },
      ];
    },
  },
  watch: {
    // Same component for the new-company and conversion routes: reload when switching.
    '$route.name': function () {
      this.items = [];
      this.filter = '';
      this.dateFrom = today();
      this.dateTo = today();
      this.pagination = {};
      this.fetchData(1);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    homeLabel,
    fetchData(page) {
      // Ignore responses to superseded searches (the API can be slow).
      const seq = ++this.requestSeq;
      if (page) this.$set(this.pagination, 'current_page', page);
      this.$store.commit('Loading_State', true);
      this.$axios
        .get(`${this.kind.api}/approved`, {
          params: {
            page: this.pagination.current_page,
            per_page: 20,
            filter: this.filter || undefined,
            date_from: this.dateFrom || undefined,
            date_to: this.dateTo || undefined,
          },
        })
        .then((res) => {
          if (seq !== this.requestSeq) return;
          this.items = res.data.data.data;
          this.pagination = res.data.data.pagination;
        })
        .catch((error) => {
          const data = (error.response && error.response.data) || {};
          this.$store.commit('Toast_State', { value: true, color: 'error', msg: data.message || 'Something went wrong' });
        })
        .finally(() => {
          this.$store.commit('Loading_State', false);
        });
    },
  },
};
</script>
